import React from "react";

const Mission = () => {
  return (
    <section id="mission" className="mission py-5">
      <div className="container">
        <div className="text-center mb-5 section-header">
          <span className="badge rounded-pill px-3 py-2 mb-3" 
                style={{background: "var(--chip)", color: "var(--chiptext)"}}>
            Our Mission
          </span>
          <h2 className="display-5 fw-bold mb-3" style={{color: "var(--secondarytext)"}}>
            Driving Innovation Through Purpose
          </h2>
          <div className="divider mx-auto mb-4"></div>
          <p className="lead mx-auto" style={{maxWidth: "600px", color: "var(--secondarytext)", opacity: 0.8}}>
            We're committed to creating hardware solutions that make a meaningful impact on industries and communities worldwide.
          </p>
        </div>

        <div className="row">
          <div className="col-md-4 mb-4">
            <div className="mission-card h-100 p-4 text-center">
              <div className="mission-icon mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="h4 mb-3" style={{color: "var(--secondarytext)"}}>Innovate</h3>
              <p style={{color: "var(--secondarytext)", opacity: 0.8}}>
                Develop groundbreaking technologies that push the boundaries of what's possible in our
                industry.
              </p>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="mission-card h-100 p-4 text-center">
              <div className="mission-icon mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="h4 mb-3" style={{color: "var(--secondarytext)"}}>Collaborate</h3>
              <p style={{color: "var(--secondarytext)", opacity: 0.8}}>
                Work with partners and clients to create tailored solutions that address specific
                challenges.
              </p>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="mission-card h-100 p-4 text-center">
              <div className="mission-icon mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="h4 mb-3" style={{color: "var(--secondarytext)"}}>Transform</h3>
              <p style={{color: "var(--secondarytext)", opacity: 0.8}}>
                Implement technologies that fundamentally improve processes and experiences across
                industries.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .mission {
          background: linear-gradient(to bottom, white 0%, var(--canvas) 100%);
        }
        
        .divider {
          width: 80px; 
          height: 4px; 
          background: var(--primary);
          border-radius: 999px; 
        }
        
        .mission-card {
          background: var(--card);
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          transition: all 0.3s ease;
          border: 1px solid var(--cardborder);
        }
        
        .mission-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
        }
        
        .mission-icon {
          width: 80px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--chip);
          color: var(--primary);
          border-radius: 50%;
          stroke-width: 1.5;
        }
        
        .mission-card:hover .mission-icon {
          background: var(--primary);
          color: white;
          transition: all 0.3s ease;
        }
        
        @media (max-width: 768px) {
          .mission-grid {
            gap: 1.5rem;
          }
        }
      `}</style>
    </section>
  );
};

export default Mission;